import { Component, OnInit, HostListener, ElementRef } from '@angular/core';

import { IParallaxScrollConfig } from 'ngx-parallax-scroll';

import ScrollBound from "scroll-bound-animation";



@Component({
  selector: 'app-animation-logo',
  templateUrl: './animation-logo.component.html',
  styleUrls: ['./animation-logo.component.scss']
})
export class AnimationLogoComponent implements OnInit {

  public itsMobile = false;

  ngParallaxConf: IParallaxScrollConfig = {
    parallaxSpeed: 1,
    parallaxSmoothness: 1,
    parallaxDirection: 'reverse',
    parallaxTimingFunction: 'ease-in',
    parallaxThrottleTime: 80
  };

  constructor(private el: ElementRef) { }

  ngOnInit(): void {
    if (this.verifyMobile()) {
      this.itsMobile = true;
    }

    /* if(screen.height <= 720){
      var data = require("../mena-region/animation-mena-700.json");
    }else if(screen.height <= 1000){
      var data = require("../mena-region/animation-mena-900.json");
    }else if(screen.height > 1000){
      var data = require("../mena-region/animation-mena.json");
    } */

    /* if(screen.height < 750 && window.innerWidth <= 1280){
      var data = require("../mena-region/animation-mena-700.json");
    }

    if(screen.height <= 900 && screen.height > 750 && window.innerWidth <= 1440 && window.innerWidth > 1280){
      var data = require("../mena-region/animation-mena-900.json");
    }
    
    if(screen.height <= 960 && screen.height > 900 && window.innerWidth <= 1800 && window.innerWidth > 1440){
      var data = require("../mena-region/animation-mena-1800.json");
    }

    if(screen.height <= 1040 && screen.height > 960 && window.innerWidth <= 1792 && window.innerWidth > 1440){
      var data = require("../mena-region/animation-mena-1790.json");
    }

    if(screen.height <= 1269 && screen.height > 1040 && window.innerWidth <= 2560 && window.innerWidth > 1792){
      var data = require("../mena-region/animation-mena.json");
    }
    
    new ScrollBound(data); */

  }

  verifyMobile(): any {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i
    ];


    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
  }

}
